import { createMuiTheme } from "@material-ui/core/styles";

const dense_theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        padding: "1px"
      },
      paddingNone: {
        padding: "1px"
      }
    },
    MuiIconButton: {
      root: {
        padding: "2px"
      }
    }
  }
});

export { dense_theme };
